import React from 'react'

import {
    defaultsWereChanged,
    trackedClick,
    getMarkedCookieValue,
    serialize,
} from 'utils'

class TrackedButtonWithNext extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            url: global.INTENTO_CONSOLE_URL || process.env.INTENTO_CONSOLE_URL,
        }
    }

    render() {
        const { url } = this.state
        const { slug } = this.props
        const href = `${url}?next=${window.location}#mt-demo`
        return (
            <a
                tabIndex="0"
                className="button button--sm button--blue"
                onClick={trackedClick(`Sign up clicked`, {
                    source: 'Demo',
                    title: slug,
                })}
                href={href}
                title="Sign up"
            >
                Sign up
            </a>
        )
    }
}

class TryWarning extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            production: getMarkedCookieValue('IPK'),
            token: getMarkedCookieValue('UAT')
        }
    }

    render() {
        const { production, token } = this.state
        const { slug, capabilities } = this.props

        if (production) {
            return null
        }

        if (token) {
            const letter = {
                subject: 'Production key request',
                body: `Dear Intento, \n\n\nPlease provide me the production key for the Intento API.\n\n\nBest regards,\n`,
            }
            const mailtoUrl = `mailto:hello@inten.to?${serialize(letter)}`

            const mailtoLink = (
                <a
                    onClick={trackedClick('Mailto link clicked', {
                        source: 'Intent Demo: warning',
                        title: slug,
                    })}
                    target="_blank"
                    rel="noopener noreferrer"
                    href={mailtoUrl}
                >
                    hello@inten.to
                </a>
            )

            return (
                <div className="try-intento__warning">
                    You are using Intento in the trial mode. To unlock
                    Intento&apos;s full potential you need to sign a Commercial
                    License Agreement. Please, reach us at {mailtoLink}.
                </div>
            )
        }

        const defaultsAreChanged = defaultsWereChanged(slug, capabilities)

        if (!defaultsAreChanged) {
            return (
                <div className="try-intento__warning">
                    This demo shows a cached result. Please, sign up to see how
                    your own input is processed.
                    <div className="try-intento__button-wrap">
                        <TrackedButtonWithNext slug={slug} />
                    </div>
                </div>
            )
        }

        // You need to sign a Commercial License Agreement to use the web tools.
        // Please, reach us at hello@inten.to.
        return (
            <div className="try-intento__warning-top">
                Please, sign up to see how your own input is processed.
                <div className="try-intento__button-wrap">
                    <TrackedButtonWithNext slug={slug} />
                </div>
            </div>
        )
    }
}

export default TryWarning



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/components/TryWarning.jsx